module.exports = __webpack_public_path__ + "img/background.80f6cb91.png";